import {
	ALL_ENERGY_WIDGETS_DASHBOARD_ID,
	ALL_ENERGY_WIDGETS_DASHBOARD_ROUTE,
	ENERGY_DASHBOARD_ID,
	ENERGY_DASHBOARD_ROUTE,
} from 'src/components/EnergyMonitoring/v2/energy-v2-types';

export {
	ALL_ENERGY_WIDGETS_DASHBOARD_ID,
	ALL_ENERGY_WIDGETS_DASHBOARD_ROUTE,
	ENERGY_DASHBOARD_ID,
	ENERGY_DASHBOARD_ROUTE,
};

export const ENERGY_MONITORING_DASHBOARD_TAB = {
	id: ENERGY_DASHBOARD_ID,
	key: 'energy_monitoring',
	text: 'tab_energy_monitoring',
	defaultText: 'Energy',
	route: ENERGY_DASHBOARD_ROUTE,
	icon: 'fas fa-bolt',
	backgroundColor: 'color-0',
} as const;

export const ALL_ENERGY_WIDGETS_DASHBOARD_TAB = {
	id: ALL_ENERGY_WIDGETS_DASHBOARD_ID,
	key: 'all_energy_widgets',
	text: 'All Energy Widgets',
	defaultText: 'All Energy Widgets',
	route: ALL_ENERGY_WIDGETS_DASHBOARD_ROUTE,
	icon: 'fas fa-grid-2',
	backgroundColor: 'color-0',
} as const;

export const ENERGY_MONITORING_PRIMARY_TAB_ROUTE = ENERGY_DASHBOARD_ROUTE;

export const resolveEnergyMonitoringDashTabIndex = (
	tabs: { id?: number; route?: string }[],
	location: string,
	currentDashId?: string,
): number => {
	if (isEnergyMonitoringLocation(location)) {
		const requestedId = location.split('/').filter(Boolean).pop();
		if (Number(requestedId) === ALL_ENERGY_WIDGETS_DASHBOARD_ID) {
			return tabs.findIndex((tab) => Number(tab.id) === ALL_ENERGY_WIDGETS_DASHBOARD_ID);
		}
		return tabs.findIndex(
			(tab) =>
				Number(tab.id) === ENERGY_DASHBOARD_ID ||
				tab.route === ENERGY_MONITORING_PRIMARY_TAB_ROUTE,
		);
	}

	if (!currentDashId) return -1;
	return tabs.findIndex((tab) => tab.route === `/${currentDashId}`);
};

export const isEnergyMonitoringDashboardId = (id: string | number | undefined | null) =>
	Number(id) === ENERGY_DASHBOARD_ID;

export const isEnergyMonitoringLocation = (location: string) => {
	const segment = location.split('/').filter(Boolean).pop() ?? '';
	return (
		segment === ENERGY_DASHBOARD_ROUTE.slice(1) ||
		segment === String(ENERGY_DASHBOARD_ID) ||
		segment === String(ALL_ENERGY_WIDGETS_DASHBOARD_ID)
	);
};
